// UKOI — wishlist («обране») на localStorage. Серце на картках/PDP, лічильник у хедері, сторінка обраного.
(function () {
  var KEY = 'ukoi_wishlist';
  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'UAH';

  // Єдиний набір іконок хедера (Lucide) — акаунт / обране / кошик в одному стилі.
  var LUCIDE = {
    user: '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>',
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    search: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
    menu: '<path d="M4 12h16"/><path d="M4 6h16"/><path d="M4 18h16"/>',
    x: '<path d="M18 6 6 18"/><path d="M6 6l12 12"/>'
  };
  function lucidify(svg, name) {
    if (!svg || !LUCIDE[name]) return;
    if (svg.classList.contains('ukoi-hicon')) return; // вже підмінено — щоб не зациклити спостерігач
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.removeAttribute('width'); svg.removeAttribute('height');
    svg.classList.add('ukoi-hicon');
    svg.innerHTML = LUCIDE[name];
  }
  function unifyHeaderIcons() {
    lucidify(document.querySelector('.account-button__icon'), 'user');
    lucidify(document.querySelector('.header-actions__cart-icon .svg-wrapper svg'), 'bag');
    document.querySelectorAll('.search-action svg').forEach(function (s) { lucidify(s, 'search'); });
    document.querySelectorAll('.header-drawer-icon--open svg').forEach(function (s) { lucidify(s, 'menu'); });
    document.querySelectorAll('.header-drawer-icon--close svg').forEach(function (s) { lucidify(s, 'x'); });
  }

  // хедер (і його web-компоненти) можуть домальовувати іконки після init — ловимо це спостерігачем
  function watchHeader() {
    var hdr = document.querySelector('#header-component') || document.querySelector('header') || document.body;
    if (!hdr || hdr.__ukoiWatched) return;
    hdr.__ukoiWatched = true;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        unifyHeaderIcons(); // ідемпотентна: вже підмінені пропускає
        if (!document.querySelector('.ukoi-wish-header')) { injectHeaderLink(); updateCount(); }
      });
    }).observe(hdr, { childList: true, subtree: true });
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1; // true = added
  }

  function fmtMoney(cents) {
    var v = (cents / 100);
    // формат як у теми (₴ + число); тисячі — кома, копійки лише якщо є
    var s = v.toLocaleString('uk-UA', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return '₴' + s;
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('.ukoi-wish[data-handle]').forEach(function (btn) {
      var active = has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Прибрати з обраного' : 'Додати в обране');
    });
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
    });
    // ховаємо «пузир» при 0 — так само, як нативний cart-bubble
    document.querySelectorAll('.ukoi-wish-bubble').forEach(function (bub) {
      bub.classList.toggle('visually-hidden', n === 0);
    });
    // лічильник «обране» у drawer
    document.querySelectorAll('.ukoi-drawer-wish__count').forEach(function (el) {
      el.hidden = n === 0;
    });
  }

  // делеговані кліки по серцю
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ukoi-wish[data-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.handle);
    syncButtons();
    updateCount();
    if (document.querySelector('[data-wishlist-page]')) renderPage();
  });

  // лічильник у хедері (інжектимо поряд з кошиком, не чіпаючи розмітку теми)
  function injectHeaderLink() {
    if (document.querySelector('.ukoi-wish-header')) return;
    // знаходимо кнопку/обгортку кошика й вставляємо серце ПОРУЧ (сиблінгом), а не всередину
    var cartIcon = document.querySelector('header cart-icon, header .header-actions__cart-icon, header [class*="cart-icon"]');
    var target = cartIcon ? cartIcon.closest('.header-actions__action, li, button, a') : null;
    if (!target || !target.parentNode) {
      var acct = document.querySelector('header a[href*="/account"]');
      target = acct ? (acct.closest('.header-actions__action, li, button, a') || acct) : null;
    }
    if (!target || !target.parentNode) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header-actions__action button-unstyled ukoi-wish-header';
    a.setAttribute('aria-label', 'Обране');
    a.innerHTML =
      '<svg class="ukoi-hicon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        LUCIDE.heart +
      '</svg>' +
      '<div class="cart-bubble ukoi-wish-bubble visually-hidden" data-maintain-ratio style="--cart-bubble-background: #1D1D1B; --cart-bubble-text: #FAF9F6; --cart-bubble-background-fallback: #1D1D1B; --cart-bubble-text-fallback: #FAF9F6;">' +
        '<span class="cart-bubble__background"></span>' +
        '<span class="cart-bubble__text"><span class="cart-bubble__text-count" data-wishlist-count>0</span></span>' +
      '</div>';
    target.parentNode.insertBefore(a, target);
  }

  // сторінка «Обране»
  function renderPage() {
    var wrap = document.querySelector('[data-wishlist-page]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-wishlist-grid]');
    var empty = wrap.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      products.forEach(function (p) {
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var onSale = p.compare_at_price && p.compare_at_price > p.price;
        var pct = onSale ? Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
        var price = onSale
          ? '<span class="ukoi-card__sale">' + fmtMoney(p.price) + '</span> <s>' + fmtMoney(p.compare_at_price) + '</s>' + (pct > 0 ? ' <span class="ukoi-disc">−' + pct + '%</span>' : '')
          : fmtMoney(p.price);
        var el = document.createElement('div');
        el.className = 'product-card ukoi-card';
        el.innerHTML =
          '<div class="ukoi-card__media">' +
            '<button type="button" class="ukoi-wish is-active" data-wishlist data-handle="' + p.handle + '" aria-label="Прибрати з обраного" aria-pressed="true">' +
              '<svg class="ukoi-wish__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
            '</button>' +
            '<a class="ukoi-card__medialink" href="/products/' + p.handle + '"><div class="card-gallery">' + (img ? '<img src="' + img + '&width=500" alt="' + (p.title || '') + '" loading="lazy">' : '') + '</div></a>' +
          '</div>' +
          '<a class="ukoi-card__info" href="/products/' + p.handle + '">' +
            '<span class="ukoi-card__title">' + (p.title || '') + '</span>' +
            '<span class="ukoi-card__price">' + price + '</span>' +
          '</a>';
        grid.appendChild(el);
      });
      syncButtons(grid);
    });
  }

  function init() {
    unifyHeaderIcons();
    syncButtons();
    updateCount();
    injectHeaderLink();
    updateCount();
    renderPage();
    watchHeader();
    window.addEventListener('load', unifyHeaderIcons);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
